// extracted by mini-css-extract-plugin
export default {"bot-avatar-container":"bot-avatar-container__OhpkfbVVTK8Y","avatar":"avatar__goenGrEwyEWQ"};